<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level"><br class="calibre1"/></div>
<div class="sgc-toc-level">
<a class="calibre5" href="#/Text/NA_001">No Angels</a>
<div class="sgc-toc-level1">
<a class="calibre5" href="#/Text/NA_004_toc">Table of Contents</a>
</div>
<div class="sgc-toc-level1"><br class="calibre1"/></div>
<div class="sgc-toc-level1"><br class="calibre1"/></div>
</div>
<div class="sgc-toc-level">
<span class="calibre5" href="#/Text/ST_001" title="Link target outside of Sample">Smooth Talker</span>
<div class="sgc-toc-level1">
<span class="calibre5" href="#/Text/ST_005_toc_split_000" title="Link target outside of Sample">Table of Contents</span>
</div>
<div class="sgc-toc-level1"><br class="calibre1"/></div>
<div class="sgc-toc-level1"><br class="calibre1"/></div>
</div>
<div class="sgc-toc-level">
<span class="calibre5" href="#/Text/RT_001" title="Link target outside of Sample">Rough Trade</span>
<div class="sgc-toc-level1">
<span class="calibre5" href="#/Text/RT_005_toc" title="Link target outside of Sample">Table of Contents</span>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?524c70a8